// Turns a raw i18n key like 'cart.shippingCalculated' into a readable admin
// label like "Shipping Calculated" — the key itself stays visible as small
// secondary text, this is just what a non-technical admin reads first.
export function humanizeKey(key: string): string {
  const last = key.split('.').pop() ?? key;
  const spaced = last.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function humanizeNamespace(namespace: string): string {
  const spaced = namespace.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
